module.exports = __webpack_public_path__ + "static/media/providerInviteBackgroundBottom.354101eb.jpeg";